(function(){
  var grid = document.querySelector(".review-grid");
  if (!grid) return;
  
  var dataFile = grid.dataset.source;
  if (!dataFile) return;
  
  var reviews = [];
  var loaded = 0;
  var batchSize = 20;
  var loading = false;
  
  function stars(n) {
    return "\u2605".repeat(n) + "\u2606".repeat(5-n);
  }
  
  function esc(s) {
    var d = document.createElement("div");
    d.textContent = s || "";
    return d.innerHTML;
  }
  
  function renderCard(r) {
    var card = document.createElement("div");
    card.className = "review-card";
    card.style.opacity = "0";
    card.style.transform = "translateY(12px)";
    card.style.transition = "opacity 0.3s ease, transform 0.3s ease";
    
    var html = '<div class="review-card__header">' +
      '<span class="review-card__author">' + esc(r.a) + '</span>' +
      '<span class="review-card__stars">' + stars(r.r) + '</span></div>' +
      '<div class="review-card__badge">\u2713 VERIFIED PURCHASE</div>';
    if (r.t) html += '<h4 class="review-card__title">' + esc(r.t) + '</h4>';
    if (r.p) html += '<div class="review-card__img-wrap"><img src="' + r.p + '" alt="Photo by ' + esc(r.a) + '" loading="lazy" class="review-card__photo"></div>';
    html += '<p class="review-card__body">' + esc(r.b) + '</p>';
    html += '<div class="review-card__meta"><span class="review-card__date">' + (r.d || '') + '</span></div>';
    card.innerHTML = html;
    
    // Handle image load/error via JS, not inline attributes
    var img = card.querySelector(".review-card__photo");
    if (img) {
      img.addEventListener("load", function() {
        this.parentNode.style.minHeight = "auto";
        this.style.opacity = "1";
      });
      img.addEventListener("error", function() {
        this.parentNode.style.display = "none";
      });
    }
    
    return card;
  }
  
  function loadMore() {
    if (loading || loaded >= reviews.length) return;
    loading = true;
    var end = Math.min(loaded + batchSize, reviews.length);
    var frag = document.createDocumentFragment();
    var newCards = [];
    for (var i = loaded; i < end; i++) {
      var card = renderCard(reviews[i]);
      newCards.push(card);
      frag.appendChild(card);
    }
    grid.appendChild(frag);
    loaded = end;
    
    requestAnimationFrame(function() {
      newCards.forEach(function(c, idx) {
        setTimeout(function() {
          c.style.opacity = "1";
          c.style.transform = "translateY(0)";
        }, idx * 15);
      });
    });
    
    setTimeout(function() { loading = false; }, 200);
    
    var counter = document.getElementById("review-counter");
    if (counter) counter.textContent = "Showing " + loaded + " of " + reviews.length + " reviews";
    
    if (loaded >= reviews.length) {
      var sp = document.getElementById("scroll-spinner");
      if (sp) sp.style.display = "none";
      var em = document.getElementById("scroll-end");
      if (em) em.style.display = "block";
    }
  }
  
  window.__loadMore = loadMore;
  
  var spinner = document.createElement("div");
  spinner.id = "scroll-spinner";
  spinner.style.cssText = "text-align:center;padding:30px;color:#d4a853;font-size:14px;";
  spinner.innerHTML = '<div style="display:inline-block;width:30px;height:30px;border:3px solid #d4a853;border-top-color:transparent;border-radius:50%;animation:spin 1s linear infinite;"></div><br>Loading more reviews...';
  grid.parentNode.insertBefore(spinner, grid.nextSibling);
  
  var endMsg = document.createElement("div");
  endMsg.id = "scroll-end";
  endMsg.style.cssText = "text-align:center;padding:30px;color:#666;font-size:14px;display:none;";
  endMsg.textContent = "You've seen all the reviews!";
  grid.parentNode.insertBefore(endMsg, spinner.nextSibling);
  
  var style = document.createElement("style");
  style.textContent = "@keyframes spin{to{transform:rotate(360deg)}}.review-card__img-wrap{min-height:200px;position:relative;margin:8px 0 12px}.review-card__photo{border-radius:8px;max-width:100%;height:auto;opacity:0;transition:opacity 0.3s ease}";
  document.head.appendChild(style);
  
  var ticking = false;
  window.addEventListener("scroll", function() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(function() {
        ticking = false;
        if (loaded >= reviews.length) return;
        var sr = spinner.getBoundingClientRect();
        if (sr.top < window.innerHeight + 800) {
          loadMore();
        }
      });
    }
  }, {passive: true});
  
  fetch(dataFile)
    .then(function(r) { return r.json(); })
    .then(function(data) {
      reviews = data;
      grid.innerHTML = "";
      loaded = 0;
      loadMore();
    })
    .catch(function(e) {
      console.error("Failed to load reviews:", e);
    });
})();
